/** @format */

import { configureStore } from "@reduxjs/toolkit";
import MapPositionSlice from "./MapPositionSlice";
import LanguageSlice from "./LanguageSlice";
import DetailReportSlice from "./DetailReportSlice";
import FollowReportSlice from "./FollowReportSlice";
import RouteSlice from "./RouteSlice";

export const store = configureStore({
  reducer: {
    mapPosition: MapPositionSlice,
    language: LanguageSlice,
    pageRoute: RouteSlice,
    detailReport: DetailReportSlice,
    followReport: FollowReportSlice,
  },
});
